import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class CustomerContactReferenceService extends BaseReferenceService {
  constructor() {
    super('CustomerContactReference');
  }
  getForCustomer(customerId: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/Customer/${customerId}`);
  }

  // The sales order line's On Behalf Of list: labelled "Forename Surname - Department - Contact
  // Type", email for unnamed contacts (listed last). selectedId keeps the line's current contact
  // in the list even if it has since been made obsolete.
  getOnBehalfOf(customerId: string, selectedId?: string): Observable<IdDescription[]> {
    const url = `${this.apiUrl}/OnBehalfOf/${customerId}` + (selectedId ? `/${selectedId}` : '');
    return this.httpService.get<IdDescription[]>(url);
  }
}
